import * as React from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';

import './Layout.css';

export default class Layout extends React.PureComponent<{}, { children?: React.ReactNode }> {
    public render() {
        return (
            <React.Fragment>
                <NavMenu />
                <div className="app">
                    <Container className="app-container">
                        <div className="app-content">
                            {this.props.children}
                        </div>
                        <footer className="app-footer">
                            <div className="container">
                                <span className="text-muted">&copy;&nbsp;2024&nbsp;-&nbsp;GDS Link&nbsp;-&nbsp;</span>
                                <a href="privacy">Privacy</a>
                            </div>
                        </footer>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}
